import React, { useEffect, useState } from 'react'
import AvatarUploader from '../../FormComponents/AvatarUploader';
import { toastSuccess, toastError } from '../../FormComponents/Toasts';
import { Person } from 'react-bootstrap-icons';
import axiosService from '../../../utils/AxiosService';

const EditProjectManagerProfile = () => {
  const [avatarPic, setAvatarPic] = useState(null)

  const getAvatarPic = () => {
    axiosService
      .get('/api/project_manager/profile/get_avatar_pic')
      .then(pic => setAvatarPic(pic))
      .catch(err => console.log(err))
  }

  useEffect(() => getAvatarPic(), [])

  return (
    <div className='flex h-screen'>
      <div className="m-auto w-1/4 flex flex-col align-center">
        {
          avatarPic ? (
            <div
              className='rounded-full border-2 border border-sky-500 text-rb-green m-auto h-40 w-40 mb-8'
              style={{
                background: `url("${avatarPic.url}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }}
            />
          ) : (
            <div
               className='rounded-full border-2 border border-sky-500 text-rb-green m-auto h-40 w-40 mb-8 flex items-center justify-center'
            >
              <Person />
            </div>
          )
        }
        <AvatarUploader
          url='/api/project_manager/profile/set_avatar'
          onDocumentUpload={(pic) => {
            toastSuccess("Avatar pic updated!")
            console.log(pic)
            setAvatarPic(pic)
          }}
          onDocumentUploadFailure={(error) => toastError(error)}
        />
      </div>
    </div>
   );
}

export default EditProjectManagerProfile;
